import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  stepContainer: {
    margin: theme.spacing(8, 0),
  },
}));
